import { render } from "./Loading.vue?vue&type=template&id=36e2ad24"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=36e2ad24&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36e2ad24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36e2ad24', __exports__)) {
    api.reload('36e2ad24', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=36e2ad24", () => {
    api.rerender('36e2ad24', render)
  })

}


export default __exports__